// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html {
  scroll-behavior: smooth;
}


@keyframes growShrink {
    0%, 100% {
      transform: scale(1);
    }
   
    50% {
      transform: scale(0.7);
    }
  }
  
  .grow-shrink {
    animation: growShrink 7s ease-in-out infinite;
  }


  
  `, "",{"version":3,"sources":["webpack://./src/PortfolioComponents/Anim.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;AACzB;;;AAGA;IACI;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,6CAA6C;EAC/C","sourcesContent":["\nhtml {\n  scroll-behavior: smooth;\n}\n\n\n@keyframes growShrink {\n    0%, 100% {\n      transform: scale(1);\n    }\n   \n    50% {\n      transform: scale(0.7);\n    }\n  }\n  \n  .grow-shrink {\n    animation: growShrink 7s ease-in-out infinite;\n  }\n\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
